import { render } from "./WaveData.vue?vue&type=template&id=f8a69c10"
import script from "./WaveData.vue?vue&type=script&lang=js"
export * from "./WaveData.vue?vue&type=script&lang=js"

import "./WaveData.vue?vue&type=style&index=0&id=f8a69c10&lang=css"

import exportComponent from "C:\\ami-website\\www-restore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__